import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AgentApi, AgentApiImpl } from './apis';

export const agentContainer = new ContainerModule((bind) => {
  bind(AgentApi).to(AgentApiImpl);
});
